import { Link } from "react-router-dom";
import { Camera, Ruler, ArrowRight } from "lucide-react";

const FEATURES = [
  {
    icon: Camera,
    overline: "Virtual Try-On",
    title: "See it on you before you buy",
    copy: "Upload your photo and preview any outfit on yourself in seconds — no fitting room needed.",
    cta: "Try it now",
    to: "/shop",
    id: "tryon",
  },
  {
    icon: Ruler,
    overline: "Every Size, Every Body",
    title: "Styles from XXS to 4XL",
    copy: "Most of our collection runs up to 4XL — and our Plus Size Diva edit is made to flatter.",
    cta: "Shop plus sizes",
    to: "/shop?collection=plus-size-collection",
    id: "plus-size",
  },
];

export const FeatureHighlights = () => (
  <section data-testid="feature-highlights" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-14 sm:py-20">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
      {FEATURES.map((f) => (
        <div key={f.id} data-testid={`feature-${f.id}`}
          className="group bg-[#EFEFEA] px-8 py-10 sm:px-12 sm:py-14 flex flex-col items-start hover:bg-[#1A1A1A] transition-colors duration-500">
          <f.icon size={30} strokeWidth={1.2} className="text-[#B84A3B] group-hover:text-[#F5C542] transition-colors duration-500" />
          <p className="font-mono text-[0.62rem] tracking-[0.28em] uppercase text-[#B84A3B] group-hover:text-[#F5C542] mt-6 transition-colors duration-500">{f.overline}</p>
          <h3 className="font-display text-2xl sm:text-3xl text-[#1A1A1A] group-hover:text-white mt-2 transition-colors duration-500">{f.title}</h3>
          <p className="font-body text-sm text-[#6E6E69] group-hover:text-white/70 mt-3 leading-relaxed transition-colors duration-500">{f.copy}</p>
          <Link to={f.to} data-testid={`feature-${f.id}-cta`}
            className="inline-flex items-center gap-2 mt-6 text-[0.68rem] font-mono tracking-[0.18em] uppercase text-[#1A1A1A] group-hover:text-white border-b border-[#1A1A1A] group-hover:border-white pb-1 transition-colors duration-500">
            {f.cta} <ArrowRight size={13} />
          </Link>
        </div>
      ))}
    </div>
  </section>
);
